import React from "react";

interface DropdownShimmerProps {
  count?: number;
  className?: string;
}

const DropdownShimmer: React.FC<DropdownShimmerProps> = ({ 
  count = 5, 
  className = "" 
}) => {
  return (
    <div className={`space-y-3 ${className}`}>
      {[...Array(count)].map((_, index) => (
        <div 
          key={index} 
          className="h-6 w-full shimmer skeleton rounded-md"
        />
      ))}
    </div>
  );
};

export default DropdownShimmer;

